<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <!-- Page de chargement -->
    <div v-if="!authStore.initialized" class="flex items-center justify-center min-h-screen">
      <div class="text-center">
        <div class="animate-spin rounded-full h-16 w-16 border-b-4 border-gray-900 mx-auto mb-4"></div>
        <p class="text-gray-600 text-lg">Chargement...</p>
      </div>
    </div>
    
    <!-- Contenu principal -->
    <RouterView v-else />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()

onMounted(async () => {
  // Vérifier l'authentification au démarrage
  await authStore.checkAuth()
})
</script>